<template>
  <div style="max-width: 1000px; margin-bottom: 100px">
    <h1 v-bg-typography="'h1'">
      Hi
      {{ $store.state.user.user.profile.first_name }}
    </h1>
    <div
      class="top"
      v-if="
        $store.state.user.user &&
        $store.state.user.user.company &&
        ($store.state.user.user.role === 'member' ||
          $store.state.user.user.role === 'admin')
      "
    >
      <div class="time top-title">
        <p style="font-size: 10pt">Company:</p>
        <p style="font-weight: 600">
          {{
            ($store.state.user.user.company &&
              $store.state.user.user.company.name) ||
            "No Company"
          }}
        </p>
      </div>

      <div
        class="time top-title"
        v-if="
          $store.state.companies.company &&
          $store.state.companies.company.contract
        "
      >
        <p style="font-size: 10pt">Subscription</p>
        <div style="display: flex; align-items: center; gap: 5px">
          <div
            style="
              background-color: #00deab;
              border-radius: 100%;
              width: 10px;
              height: 10px;
            "
          ></div>
          <p
            v-if="$store.state.companies.company.contract.is_active"
            style="font-weight: 600"
          >
            Active
          </p>
        </div>
      </div>

      <div
        class="time top-title"
        v-if="
          $store.state.companies.company &&
          $store.state.companies.company.contract
        "
      >
        <p style="font-size: 10pt">Renewal date:</p>
        <p style="font-weight: 600">
          {{ $store.state.companies.company.contract.endDate }}
        </p>
      </div>

      <div
        v-if="
          $store.state.companies.company &&
          $store.state.companies.company.contract
        "
        class="time top-title"
      >
        <p style="font-size: 10pt">Tests:</p>
        <p style="font-weight: 600">
          {{
            $store.state.companies.company.contract.available_tests.essential +
            $store.state.companies.company.contract.available_tests.professional
          }}
          Available
        </p>
      </div>

      <div class="time top-title" v-if="$store.state.companies.company">
        <p style="font-size: 10pt">Admin</p>
        <p style="font-weight: 600">
          {{ $store.state.companies.company.admin.profile.first_name }}
        </p>
      </div>
    </div>

    <div>
      <p><b>Recent tests</b></p>
      <div
        v-if="$store.state.tests.loading_recent"
        style="position: relative; height: 240px"
      >
        <bg-loader type="circle" :dark="true"></bg-loader>
      </div>
      <div v-else class="tests">
        <div
          v-if="recent_tests.length < 4"
          class="no_test"
          @click="$router.push('/create-test')"
        >
          <h3>
            Create a <br />
            new test
          </h3>
        </div>

        <div v-for="test in recent_tests" :key="test.id">
          <div
            class="test_card"
            :class="`${test.state}_background`"
            @click="$router.push(generateTestLink(test))"
          >
            <p
              class="line-clamp"
              style="color: white; font-weight: 600; font-size: 12pt"
            >
              {{ test.name }}
            </p>
            <img :src="placeholders[test.platform]" />
            <p class="state">{{ test.state }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="articles">
      <p><b>Recent articles</b></p>
      <div class="articles-list" style="margin-top: 10px">
        <div v-for="a in articles" :key="a.url">
          <div class="article">
            <div style="padding: 20px 30px">
              <p class="line-clamp" style="font-weight: 600; font-size: 13pt">
                {{ a.title }}
              </p>
            </div>
            <img :src="require(`@/assets/articles/${a.image}`)" />
            <div class="button">
              <BgButton
                @click="openLink(a.url)"
                text="Read"
                variant="secondary"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <p style="margin-bottom: 10px; margin-top: 25px">
      <b>Other solutions</b>
    </p>
    <div class="solutions">
      <div class="neurolab solution">
        <div class="left">
          <p style="font-weight: 600; font-size: 10pt">#Neurolab</p>
          <div>
            <p style="font-size: 16pt; font-weight: 600">
              "With our own NeuroLab we are able to go deep into all of our UX
              topics."
            </p>
            <p style="margin-top: 10px; font-size: 10pt">
              Melvin van Gom, <br />
              Director @ Dentsu
            </p>
          </div>
          <BgButton
            @click="openLink('https://www.braingineers.com/neurolab')"
            text="Read more"
          />
        </div>
        <div class="right">
          <img
            @click="openLink('https://www.youtube.com/watch?v=1nH1-denKUM')"
            src="@/assets/imgs/neurolab.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
import BgButton from "@/components/bg-button";
import BgLoader from "@/components/bg-loader";

export default {
  components: {
    BgButton,
    BgLoader,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      articles: [
        {
          title:
            "Creativity vs UX: why it's so hard to choose a movie on Netflix or HBO",
          image: "hbo.jpg",
          url: "https://www.braingineers.com/post/video-streaming-platforms?lang=en",
        },
        {
          title:
            "Neuro-UX and experimentation: check-out experienced from a customer's point of view",
          image: "experimentation.jpeg",
          url: "https://www.braingineers.com/post/neuro-research-en-experimentation-in-de-check-out-optimaliseren-vanuit-de-echte-klantbeleving?lang=en",
        },
        {
          title:
            "Psychological Reactance: The Paradoxical Effects of (online) Influencing",
          image: "reactance.jpeg",
          url: "https://www.braingineers.com/post/psychological-reactance?lang=en",
        },
      ],
      placeholders: {
        mobile: require("@/assets/imgs/placeholder_mobile.png"),
        desktop: require("@/assets/imgs/placeholder_desktop.png"),
        both: require("@/assets/imgs/placeholder_both.svg"),
        all: require("@/assets/imgs/placeholder_all.svg"),
        video: require("@/assets/imgs/placeholder_video.svg"),
      },
    };
  },
  computed: {
    recent_tests() {
      return this.$store.state.tests.tests.slice(0, 4);
    },
  },
  methods: {
    generateTestLink(test) {
      let base = "test";
      if (test.platform === "video") {
        base = "video-test";
      }

      let editBase = test.platform === "video" ? "video" : "web";
      let testRoute = "";
      if (test.state === "done") {
        testRoute = `/${base}/${test.id}/`;
        testRoute += editBase === "video" ? "summary/" : "overview/";
      } else {
        testRoute = `/create-test/${editBase}/${test.id}`;
      }
      return testRoute;
    },
    openLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>
